'use strict';

/*@ngInject*/
module.exports = function () {
    return {
        scope: {
            object: '=',
            objectForm: '=',
            showErrors: '=',
            readOnly: '<'
        },
        bindToController: true,
        controllerAs: 'vm',
        /*@ngInject*/
        controller: function controller(sharedService) {
            var vm = this;

            vm.phonePattern = sharedService.getPhonePattern();
            vm.emailPattern = sharedService.getEmailPattern();
        },

        template: require('./public-data-entry.html')
    };
};


/** WEBPACK FOOTER **
 ** ./app/shared/directives/objects/public-data-entry.directive.js
 **/